export const managedPatternKeys = [
  'NO_CLEAR_PATTERN',
  'ASCENDING_TRIANGLE',
  'BULL_FLAG',
  'CUP_AND_HANDLE',
  'FALLING_WEDGE',
  'DOUBLE_BOTTOM',
  'INVERSE_HEAD_AND_SHOULDERS',
  'TRIPLE_BOTTOM',
  'ROUNDED_BOTTOM',
  'ACCUMULATION_BASE',
  'CHANNEL_BREAKOUT',
  'BREAKOUT_RANGE',
  'DESCENDING_TRIANGLE',
  'BEAR_FLAG',
  'RISING_WEDGE',
  'DOUBLE_TOP',
  'HEAD_AND_SHOULDERS',
  'BREAKDOWN_RANGE',
  'DISTRIBUTION_TOP',
  'TRIPLE_TOP',
  'ROUNDED_TOP',
  'RECTANGLE',
  'SYMMETRICAL_TRIANGLE',
  'CHANNEL',
  'COMPRESSION',
];

export const patternTitleByKey = {
  NO_CLEAR_PATTERN: 'Aucune figure claire',
  ASCENDING_TRIANGLE: 'Triangle ascendant',
  BULL_FLAG: 'Drapeau haussier',
  CUP_AND_HANDLE: 'Tasse avec anse',
  FALLING_WEDGE: 'Biseau descendant',
  DOUBLE_BOTTOM: 'Double creux',
  INVERSE_HEAD_AND_SHOULDERS: 'Epaule-Tete-Epaule inversee',
  TRIPLE_BOTTOM: 'Triple creux',
  ROUNDED_BOTTOM: 'Rounded bottom',
  ACCUMULATION_BASE: 'Base d accumulation',
  CHANNEL_BREAKOUT: 'Sortie de canal',
  BREAKOUT_RANGE: 'Cassure haussiere de range',
  DESCENDING_TRIANGLE: 'Triangle descendant',
  BEAR_FLAG: 'Drapeau baissier',
  RISING_WEDGE: 'Biseau ascendant',
  DOUBLE_TOP: 'Double sommet',
  HEAD_AND_SHOULDERS: 'Epaule-Tete-Epaule',
  BREAKDOWN_RANGE: 'Cassure baissiere de range',
  DISTRIBUTION_TOP: 'Sommet de distribution',
  TRIPLE_TOP: 'Triple sommet',
  ROUNDED_TOP: 'Sommet arrondi',
  RECTANGLE: 'Range rectangulaire',
  SYMMETRICAL_TRIANGLE: 'Triangle symetrique',
  CHANNEL: 'Canal',
  COMPRESSION: 'Compression',
};

export const managedPatternOptions = managedPatternKeys.map((value) => ({
  value,
  label: patternTitleByKey[value],
}));

export function getPatternTitle(patternKey) {
  if (!patternKey) {
    return '';
  }
  return patternTitleByKey[patternKey] || patternKey.replaceAll('_', ' ');
}

export const patternTutorialEntries = [
  {
    key: 'ASCENDING_TRIANGLE',
      title: 'Triangle ascendant',
    bias: 'BULLISH',
    reliability: 'High',
    schema: [44, 42, 42, 37, 42, 31, 42, 24, 42, 18, 12],
    exampleTitle: 'SOL / 4H - compression sous resistance',
    exampleReal: 'Exemple reel: une resistance plate est testee plusieurs fois pendant que les creux remontent progressivement avant le breakout.',
    context: 'Fonctionne mieux dans une tendance deja haussiere ou juste apres une impulsion claire.',
    traps: ['Breakout sans volume', 'Resistance en realite descendante', 'Structure trop courte et sans compression'],
  },
  {
    key: 'DESCENDING_TRIANGLE',
      title: 'Triangle descendant',
    bias: 'BEARISH',
    reliability: 'High',
    schema: [12, 18, 24, 18, 31, 18, 37, 18, 42, 18, 46],
    exampleTitle: 'ARB / 4H - support sous pression',
    exampleReal: 'Exemple reel: support horizontal attaque a plusieurs reprises, vendeurs de plus en plus agressifs sur les rebonds.',
    context: 'Plus propre quand le marche perd du momentum et que les rebonds deviennent de plus en plus faibles.',
    traps: ['Cassure trop precoce sur une seule meche', 'Support pas assez teste', 'Volume en baisse sur la cassure'],
  },
  {
    key: 'BULL_FLAG',
      title: 'Drapeau haussier',
    bias: 'BULLISH',
    reliability: 'High',
    schema: [50, 30, 10, 18, 22, 26, 30, 24, 18, 12],
    exampleTitle: 'INJ / 4H - pause courte apres impulsion',
    exampleReal: 'Exemple reel: impulsion verticale, puis petit canal correctif avant reprise dans le sens du mouvement initial.',
    context: 'Pattern de continuation a privilegier quand l impulsion precedente et le volume sont nets.',
    traps: ['Consolidation trop profonde', 'Drapeau trop long dans le temps', 'Pas de pole initial convaincant'],
  },
  {
    key: 'BEAR_FLAG',
      title: 'Drapeau baissier',
    bias: 'BEARISH',
    reliability: 'High',
    schema: [10, 24, 40, 34, 30, 26, 22, 28, 34, 40],
    exampleTitle: 'OP / 1H - rebond technique sous pression',
    exampleReal: 'Exemple reel: chute initiale rapide puis canal de rebond leger avant nouvelle acceleration baissiere.',
    context: 'Plus efficace dans un environnement risk-off ou apres une cassure de support importante.',
    traps: ['Rebond qui devient une vraie inversion', 'Canal trop horizontal', 'Absence de continuation vendeuse'],
  },
  {
    key: 'FALLING_WEDGE',
      title: 'Biseau descendant',
    bias: 'BULLISH',
    reliability: 'Medium-High',
    schema: [14, 20, 28, 24, 34, 30, 38, 36, 44, 42, 24],
    exampleTitle: 'ETH / 4H - essoufflement vendeur',
    exampleReal: 'Exemple reel: deux droites baissieres convergentes, la pression vendeuse ralentit progressivement.',
    context: 'Interesse surtout en fin de correction ou a proximite d un support majeur.',
    traps: ['Confusion avec un simple canal baissier', 'Sortie sans volume', 'Cassure haussiere trop faible'],
  },
  {
    key: 'RISING_WEDGE',
      title: 'Biseau ascendant',
    bias: 'BEARISH',
    reliability: 'Medium-High',
    schema: [42, 34, 30, 32, 26, 24, 24, 18, 20, 14, 34],
    exampleTitle: 'BTC / 1H - hausse fatiguee',
    exampleReal: 'Exemple reel: progression encore haussiere mais de moins en moins saine, avec des droites montantes convergentes.',
    context: 'Souvent visible en fin de rallye local ou dans un rebond technique contre tendance.',
    traps: ['Cassure prematuree interpretee comme signal', 'Wedge trop large', 'Pas de divergence de momentum'],
  },
  {
    key: 'DOUBLE_TOP',
      title: 'Double sommet',
    bias: 'BEARISH',
    reliability: 'High',
    schema: [40, 22, 14, 26, 40, 28, 46],
    exampleTitle: 'BNB / 4H - echec sous la meme resistance',
    exampleReal: 'Exemple reel: deux sommets proches au meme niveau, puis perte de la neckline.',
    context: 'Plus credible apres une hausse soutenue et lorsque la seconde tentative manque de volume.',
    traps: ['Deux sommets trop espaces', 'Deuxieme sommet nettement plus haut', 'Neckline jamais rompue'],
  },
  {
    key: 'DOUBLE_BOTTOM',
      title: 'Double creux',
    bias: 'BULLISH',
    reliability: 'High',
    schema: [16, 34, 44, 30, 16, 28, 10],
    exampleTitle: 'LINK / 4H - base de retournement',
    exampleReal: 'Exemple reel: deux creux proches sur support, puis reprise au-dessus de la neckline.',
    context: 'Fonctionne mieux apres une baisse nette et avec reprise visible de la demande sur le deuxieme creux.',
    traps: ['Deuxieme creux bien plus bas', 'Neckline non validee', 'Contexte macro encore franchement baissier'],
  },
  {
    key: 'HEAD_AND_SHOULDERS',
      title: 'Epaule-Tete-Epaule',
    bias: 'BEARISH',
    reliability: 'High',
    schema: [42, 28, 18, 32, 10, 32, 18, 28, 40],
    exampleTitle: 'BTC / 4H - perte de momentum au sommet',
    exampleReal: 'Exemple reel: epaule gauche, tete plus haute, epaule droite plus faible, puis rupture de neckline.',
    context: 'Pattern de retournement a surveiller apres extension haussiere et euphorie tardive.',
    traps: ['Epaules asymetriques', 'Tete peu marquee', 'Neckline jamais cede'],
  },
  {
    key: 'INVERSE_HEAD_AND_SHOULDERS',
      title: 'Epaule-Tete-Epaule inversee',
    bias: 'BULLISH',
    reliability: 'High',
    schema: [10, 24, 36, 22, 42, 22, 36, 24, 12],
    exampleTitle: 'ATOM / 4H - reaccumulation constructive',
    exampleReal: 'Exemple reel: structure de retournement avec un creux central plus profond, puis franchissement de neckline.',
    context: 'Particulierement utile apres une capitulation puis une stabilisation progressive.',
    traps: ['Neckline trop inclinee', 'Volume absent a la cassure', 'Fausse epaule droite trop profonde'],
  },
  {
    key: 'TRIPLE_TOP',
      title: 'Triple sommet',
    bias: 'BEARISH',
    reliability: 'Medium-High',
    schema: [40, 24, 14, 24, 40, 24, 14, 24, 40, 28, 46],
    exampleTitle: 'XRP / 4H - plafond confirme',
    exampleReal: 'Exemple reel: trois echecs consecutifs sous la meme resistance avant reprise en main par les vendeurs.',
    context: 'Le pattern gagne en valeur quand chaque retour sur resistance manque d energie.',
    traps: ['Trois sommets de niveaux differents', 'Pas de cassure de support', 'Marche trop range et sans tendance initiale'],
  },
  {
    key: 'TRIPLE_BOTTOM',
      title: 'Triple creux',
    bias: 'BULLISH',
    reliability: 'Medium-High',
    schema: [14, 28, 42, 28, 14, 28, 42, 28, 14, 24, 10],
    exampleTitle: 'ADA / 1D - base defendue a trois reprises',
    exampleReal: 'Exemple reel: trois tests de support absorbes avant sortie haussiere de la base.',
    context: 'Interesse surtout lorsque le support correspond a une zone de valeur de long terme.',
    traps: ['Support pas clairement horizontal', 'Breakout sans acceleration', 'Pattern forme au milieu de nulle part'],
  },
  {
    key: 'CUP_AND_HANDLE',
      title: 'Tasse avec anse',
    bias: 'BULLISH',
    reliability: 'High',
    schema: [18, 24, 34, 42, 46, 42, 34, 26, 22, 28, 18, 12],
    exampleTitle: 'SOL / 1D - base arrondie puis handle court',
    exampleReal: 'Exemple reel: fond arrondi, retour proche des anciens sommets puis petite respiration avant cassure.',
    context: 'Tres interessant sur les leaders de marche apres une base de reaccumulation longue.',
    traps: ['Handle trop profond', 'Cup trop en V', 'Breakout sous l ancienne resistance'],
  },
  {
    key: 'ROUNDED_BOTTOM',
      title: 'Rounded bottom',
    bias: 'BULLISH',
    reliability: 'Medium-High',
    schema: [18, 24, 30, 36, 42, 46, 42, 36, 30, 22, 14],
    exampleTitle: 'ETH / 1D - sortie lente de capitulation',
    exampleReal: 'Exemple reel: retournement progressif, sans violence, avec des creux de moins en moins defendus par les vendeurs.',
    context: 'Souvent utile sur les timeframes plus larges quand la rotation de tendance est graduelle.',
    traps: ['Confusion avec simple range', 'Patience insuffisante avant la vraie sortie', 'Pas de reprise de volume sur la fin'],
  },
  {
    key: 'ROUNDED_TOP',
      title: 'Sommet arrondi',
    bias: 'BEARISH',
    reliability: 'Medium-High',
    schema: [42, 36, 30, 24, 18, 14, 18, 24, 30, 38, 44],
    exampleTitle: 'DOGE / 1D - distribution lente en sommet',
    exampleReal: 'Exemple reel: retournement progressif avec perte de vitesse des acheteurs avant rupture de support.',
    context: 'Plus utile quand l euphorie s essouffle et que les rallies deviennent moins efficaces.',
    traps: ['Confusion avec simple consolidation', 'Signal pris trop tot', 'Support final encore intact'],
  },
  {
    key: 'CHANNEL_BREAKOUT',
      title: 'Sortie de canal',
    bias: 'BULLISH',
    reliability: 'Medium-High',
    schema: [36, 32, 28, 24, 20, 16, 12, 16, 10, 4, 2],
    exampleTitle: 'NEAR / 4H - sortie de canal propre',
    exampleReal: 'Exemple reel: canal de tendance bien dessine, puis cassure nette de la borne haute avec acceleration.',
    context: 'Pertinent quand le canal est propre et que la sortie intervient avec volume et momentum.',
    traps: ['Canal mal defini', 'Meche au-dessus sans cloture', 'Breakout deja trop etendu'],
  },
  {
    key: 'RECTANGLE',
      title: 'Range rectangulaire',
    bias: 'NEUTRAL',
    reliability: 'Medium',
    schema: [18, 18, 40, 40, 18, 18, 40, 40, 18, 18, 40],
    exampleTitle: 'BTC / 4H - congestion avant choix de direction',
    exampleReal: 'Exemple reel: support et resistance presque paralleles, marche en attente d un catalyseur.',
    context: 'Pattern utile pour cadrer le risque mais pas toujours directionnel sans confirmation supplementaire.',
    traps: ['Surinterpreter le range', 'Prendre le milieu du rectangle', 'Ignorer les faux depassements'],
  },
  {
    key: 'DISTRIBUTION_TOP',
      title: 'Sommet de distribution',
    bias: 'BEARISH',
    reliability: 'Medium-High',
    schema: [40, 30, 22, 18, 16, 18, 22, 30, 38, 44, 48],
    exampleTitle: 'AVAX / 1D - vendeurs actifs en haut de range',
    exampleReal: 'Exemple reel: le marche plafonne, les sorties haussieres echouent et les rallyes servent a distribuer.',
    context: 'A surveiller quand la hausse precedente est mature et que le flux acheteur ralentit.',
    traps: ['Assimiler toute consolidation a de la distribution', 'Absence de faiblesse relative', 'Support principal encore intact'],
  },
  {
    key: 'ACCUMULATION_BASE',
      title: 'Base d accumulation',
    bias: 'BULLISH',
    reliability: 'Medium-High',
    schema: [18, 24, 28, 30, 32, 30, 28, 26, 22, 18, 12],
    exampleTitle: 'LINK / 1D - base de reaccumulation',
    exampleReal: 'Exemple reel: marche qui arrete de baisser, absorbe l offre puis prepare une reprise plus durable.',
    context: 'Souvent plus propre sur les leaders ou sur des actifs soutenus par un theme fort.',
    traps: ['Base trop courte', 'Pas de preuve de demande', 'Contexte marche global encore trop fragile'],
  },
  {
    key: 'SYMMETRICAL_TRIANGLE',
      title: 'Triangle symetrique',
    bias: 'NEUTRAL',
    reliability: 'Medium',
    schema: [12, 18, 24, 30, 34, 30, 24, 18, 14, 18, 24],
    exampleTitle: 'BTC / 4H - compression bidirectionnelle',
    exampleReal: 'Exemple reel: les droites convergent sans biais directionnel net; le contexte exterieur decide souvent.',
    context: 'Peut casser dans les deux sens. Le pattern est surtout utile pour preparer un plan d execution.',
    traps: ['Vouloir predire le sens trop tot', 'Ignorer le contexte du trend precedent', 'Confondre avec wedge ou range'],
  },
];